<template>
  <div>
    <div class="dash_box">
      <div class="box-content-app">
        <h3>Montant total des débits</h3>
        <div class="detail_">
          <span class="st"
            ><strong
              >{{
                operations.totalSolde ? operations.totalSolde : 0
              }}
              XOF</strong
            ></span
          >
          <svg
            data-v-8316392a=""
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              data-v-8316392a=""
              cx="23"
              cy="23"
              r="23"
              fill="#28C76F"
              fill-opacity="0.12"
            ></circle>
            <path
              data-v-8316392a=""
              d="M33 22.08V23C32.9988 25.1564 32.3005 27.2547 31.0093 28.9818C29.7182 30.709 27.9033 31.9725 25.8354 32.5839C23.7674 33.1953 21.5573 33.1219 19.5345 32.3746C17.5117 31.6273 15.7847 30.2461 14.611 28.4371C13.4373 26.628 12.8798 24.4881 13.0217 22.3363C13.1636 20.1846 13.9972 18.1363 15.3983 16.4971C16.7994 14.8578 18.6928 13.7154 20.7962 13.2401C22.8996 12.7649 25.1003 12.9823 27.07 13.86"
              stroke="#28C76F"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              data-v-8316392a=""
              d="M33 15L23 25.01L20 22.01"
              stroke="#28C76F"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
      </div>
      <div class="box-content-app">
        <h3>Montant remboursé</h3>
        <div class="detail_">
          <span class="st"
            ><strong
              >{{
                operations.totalSoldeRefund ? operations.totalSoldeRefund : 0
              }}
              XOF</strong
            ></span
          >
          <svg
            data-v-8316392a=""
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              data-v-8316392a=""
              cx="23"
              cy="23"
              r="23"
              fill="#E5E5E5"
            ></circle>
            <path
              data-v-8316392a=""
              d="M23 33C28.5228 33 33 28.5228 33 23C33 17.4772 28.5228 13 23 13C17.4772 13 13 17.4772 13 23C13 28.5228 17.4772 33 23 33Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              data-v-8316392a=""
              d="M26 20L20 26"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
      </div>
      <div class="box-content-app">
        <h3>Solde actuel</h3>
        <div class="detail_">
          <span class="st"
            ><strong
              >{{
                operations.actualSolde ? operations.actualSolde : 0
              }}
              XOF</strong
            ></span
          >
          <svg
            data-v-8316392a=""
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              data-v-8316392a=""
              cx="23"
              cy="23"
              r="23"
              fill="#E5E5E5"
            ></circle>
            <path
              data-v-8316392a=""
              d="M23 33C28.5228 33 33 28.5228 33 23C33 17.4772 28.5228 13 23 13C17.4772 13 13 17.4772 13 23C13 28.5228 17.4772 33 23 33Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              data-v-8316392a=""
              d="M26 20L20 26"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <div class="pt-10">
      <div class="box-content">
        <div class="bx-p">
          <h3>Chiffre d'affaire réalisé par mois et par année</h3>
          <div>
            <drop-down title="Rechercher par année" ref="dateSearch">
              <template>
                <li>
                  <div>
                    <label>Année</label>
                    <v-select
                      :options="years"
                      placeholder="Selectionner"
                      v-model="model.year"
                      label="name"
                      :reduce="(item) => item.id"
                    ></v-select>
                  </div>
                </li>
                <li>
                  <div class="pt-10 b-flex">
                    <button
                      @click="changeYear"
                      class="button is-outlined is-small"
                    >
                      Valider
                    </button>
                    <button
                      @click="cancelSearch"
                      class="button is-outlined is-small"
                    >
                      Annuler
                    </button>
                  </div>
                </li>
              </template>
            </drop-down>
          </div>
        </div>
        <p>
          <apexchart
            type="bar"
            height="250"
            v-if="!loading_d"
            :options="graph.chartOptions"
            :series="graph.series"
          ></apexchart>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { TYPES } from "@/store/types";
import { mapGetters } from "vuex";
import apexchart from "vue-apexcharts";
import DropDown from "@/components/DropDown";
export default {
  name: "dashboardCustomer",
  components: { apexchart, DropDown },
  data: () => ({
    loading: false,
    loading_d: false,
    years: [],
    model: { year: "" },
    graph: {
      series: [],
      chartOptions: {
        chart: {
          height: 250,
          type: "bar",
        },

        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: "50%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -45,
          },
          categories: [],
          tickPlacement: "on",
        },
      },
    },
  }),
  computed: {
    ...mapGetters({
      operations: `${TYPES.modules.DASHBOARD}/${TYPES.getters.GET_CUSTOMER_OPERATION}`,
    }),
  },
  mounted() {
    this.model.year = new Date().getFullYear();
    this.getOperations();
    this.getTransactionsChart();
    this.setuptYears();
  },
  methods: {
    setuptYears() {
      const current_year = new Date().getFullYear();
      for (let index = 2015; index <= current_year; index++) {
        this.years.push({ id: index, name: index });
      }
    },

    changeYear() {
      this.getTransactionsChart();
      this.$refs.dateSearch.closeExit();
    },

    cancelSearch() {
      this.model.year = "";
      this.$refs.dateSearch.closeExit();
    },

    getOperations() {
      this.loading = true;
      this.$store
        .dispatch(
          `${
            TYPES.modules.DASHBOARD + "/" + TYPES.actions.GET_CUSTOMER_OPERATION
          }`
        )
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getTransactionsChart() {
      this.loading_d = true;
      this.$store
        .dispatch(
          `${
            TYPES.modules.DASHBOARD +
            "/" +
            TYPES.actions.GET_ADMIN_TRANSACTIONS_GRAPH_CUSTOMER
          }`,
          this.model
        )
        .then((res) => {
          this.graph.series = res.series;
          this.graph.chartOptions.xaxis.categories = res.labels;
          this.loading_d = false;
        })
        .catch(() => {
          this.loading_d = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.dash_box {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 10px;
  .d-first {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}

.box-content-app {
  background: #fff;
  //   box-shadow: 0 2rem 3rem rgba(132, 139, 200, 0.18);
  width: 100%;
  min-height: 125px;
  height: auto;
  padding: 10px;
}

.detail_ {
  display: flex;
  height: 100%;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}
.st {
  font-size: 17px;
}

@media only screen and (max-width: 650px) {
  .dash_box {
    grid-template-columns: 1fr;
    grid-auto-flow: row;
  }
}
.bx-p {
  display: flex;
  align-content: center;
  align-items: center;
  gap: 40px;
}
</style>